import { render, staticRenderFns } from "./CoursesWrapperForm.vue?vue&type=template&id=e769e468&scoped=true"
import script from "./CoursesWrapperForm.vue?vue&type=script&lang=js"
export * from "./CoursesWrapperForm.vue?vue&type=script&lang=js"
import style0 from "./CoursesWrapperForm.vue?vue&type=style&index=0&id=e769e468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e769e468",
  null
  
)

export default component.exports